import React from "react";
import { UseFormReturn } from "react-hook-form";
import { ClienteFormValues } from "../ClienteFormSchema";
import { FormattedTextField } from "@/components/form/FormattedTextField";
import { AtividadeSelect } from "../form/AtividadeSelect";
import { TextareaField } from "@/components/form/TextareaField";
import {
  PipelineFormSection,
  pipelineFieldGridClassCompact,
  usePipelineForm,
} from "@/components/form/PipelineFormContext";

interface AdditionalInfoStepProps {
  form: UseFormReturn<ClienteFormValues>;
}

export function AdditionalInfoStep({ form }: AdditionalInfoStepProps) {
  const { isPipeline } = usePipelineForm();
  const gridClass = pipelineFieldGridClassCompact(isPipeline);

  return (
    <div className={isPipeline ? 'space-y-3' : ''}>
      <PipelineFormSection>
        <div className={gridClass}>
          <FormattedTextField
            form={form}
            name="naturalidade"
            label="Naturalidade"
            formatter="texto"
            placeholder="Cidade onde nasceu"
          />

          <FormattedTextField
            form={form}
            name="nacionalidade"
            label="Nacionalidade"
            formatter="texto"
            placeholder="País de origem"
          />

          <AtividadeSelect
            form={form}
            name="atividadeDesenvolvida"
            label="Atividade"
          />

          <FormattedTextField
            form={form}
            name="rendimentoTitular"
            label="Rendimento"
            formatter="moeda"
            placeholder="R$ 0,00"
          />
        </div>
      </PipelineFormSection>

      <PipelineFormSection className={isPipeline ? 'mt-3' : 'mt-6'}>
        <TextareaField
          form={form}
          name="statusAtual"
          label="Status Atual"
          placeholder="Histórico de negociação, observações..."
          required
        />
        {!isPipeline && (
          <p className="text-sm text-gray-600 mt-1 px-1 pb-3">
            Campo obrigatório para registrar informações sobre leads que não fecharam contrato.
          </p>
        )}
      </PipelineFormSection>
    </div>
  );
}
